/**
 * 蓝牙电子秤适配器
 * 使用 Android 原生蓝牙实现
 */

import BluetoothScaleAndroidBridge, {
  WeightData,
  ErrorData,
  DeviceInfo,
  BluetoothScaleDevice,
  ConnectionResult
} from './bluetoothScaleAndroidBridge';

/**
 * 蓝牙电子秤适配器
 * 封装 Android 原生蓝牙桥接
 */
export class BluetoothScaleAdapter {
  private implementation: BluetoothScaleAndroidBridge;

  constructor() {
    this.implementation = new BluetoothScaleAndroidBridge();
  }

  /**
   * 初始化蓝牙适配器
   */
  async initBluetooth(): Promise<boolean> {
    return await this.implementation.initBluetooth();
  }

  /**
   * 搜索蓝牙设备
   */
  async requestDevice(): Promise<BluetoothScaleDevice | null> {
    return await this.implementation.requestDevice();
  }

  /**
   * 停止搜索设备
   */
  stopScan(): void {
    this.implementation.stopScan();
  }

  /**
   * 连接蓝牙设备
   */
  async connectDevice(address?: string): Promise<ConnectionResult> {
    return await this.implementation.connectDevice(address);
  }

  /**
   * 设置重量数据回调
   */
  onWeightChange(callback: (data: WeightData) => void): void {
    this.implementation.onWeightChange(callback);
  }

  /**
   * 设置错误回调
   */
  onError(callback: (data: ErrorData) => void): void {
    this.implementation.onError(callback);
  }

  /**
   * 断开连接
   */
  async disconnect(): Promise<void> {
    await this.implementation.disconnect();
  }

  /**
   * 关闭蓝牙适配器
   */
  async closeBluetooth(): Promise<void> {
    await this.implementation.closeBluetooth();
  }

  /**
   * 获取已发现的设备列表
   */
  getDiscoveredDevices(): BluetoothScaleDevice[] {
    return this.implementation.getDiscoveredDevices();
  }
}

// 导出类型
export type {
  WeightData,
  ErrorData,
  DeviceInfo,
  BluetoothScaleDevice,
  ConnectionResult
};

// 默认导出
export default BluetoothScaleAdapter;

